module.exports = __webpack_public_path__ + "static/legend-category-label-dont-cc8a59e1d76c35e3c117a6b27a37da8c.png";